<template>
  <app-base-main no-padding parentTable>
    <!-- 筛选条件 -->
    <template #filter-group>
      <app-filter-group @reset="$gjReset"  @query="$gjNoticeQuery">
        <gj-country-server-select
          v-model="filter.countryMarketValue"
        ></gj-country-server-select>
        <gj-select
          v-model="filter.currency"
          :options="financeCurrencysOption"
          :clearable="false"
        ></gj-select>
        <gj-category-select multiple v-model="filter.categoryIds" >
        </gj-category-select>
        <gj-select-date-picker-active
            :type="filter.date.key === 1 ? 'daterange' : 'monthrange'"
            v-model="filter.date"
            :options="[
              {id: 0, text: '月份'},
              {id: 1, text: '日期'},
            ]"
            :shortcuts="shortcuts"
            @input="changeDatePciker"
            :dateClearable="false"
        >
        </gj-select-date-picker-active>
      </app-filter-group>
    </template>
    <!-- 操作 -->
    <template #operate-group>
      <gj-button type="primary" @click="clickRecalculate">重算</gj-button>
    </template>
    <template #tool-group>
      <profit-report-tool
          :table-columns="columns" :table-name="tableName"
          download-url="/finance/financialProfitAnalysis/exportProfitAnalysis"
          :download-params="globalParams">
      </profit-report-tool>
    </template>
    <template #table>
      <profit-report-table-template
          show-summary :summary-object="dataTotal"
          :data="data"
          adaptParent
          :columns="columns"
          :pagination="pagination"
          :loading="loading"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
          :queryParams="setModel()"
          :customData = "expenseManagementTable"
          @refresh="$gjNoticeQuery"
      ></profit-report-table-template>
    </template>
  </app-base-main>
</template>

<script>
  import _ from "lodash";
  import ProfitReportTool from "../tool/profit-report-tool";
  import {financeProfitReport} from '../common/fields';
  import FinanceRecalculate from "modules/common/finance/finance-recalculate-modal";
  import ProfitReportTableTemplate from "./template/profit-report-table-template";
  import { exportProfitAnalysis, getFinanceAnalysisPage, queryFeeItemList, analysisStatistics } from "@/api/finance";
  import {isMeaningfulMixin, queryMixin} from "@/minxins";
  import { financeCurrencysOption } from "@/utils/options";
  import { startOfMonth, endOfMonth } from "date-fns";
  import {convertToFullDate} from "@/utils/date.util";

  export default {
    name: "finance-profit-report-category",
    components: {ProfitReportTableTemplate, ProfitReportTool},
    mixins: [queryMixin, isMeaningfulMixin],
    inject: ["getFilter", "setFilter"],
    mounted() {
      let filter = this.getFilter()
      this.filter = {...this.filter, ...filter}
    },
    beforeDestroy() {
      this.setFilter(this.filter)
    },
    data() {
      return {
        financeCurrencysOption,
        isInitParams: false,
        useCache: false,
        tableName: 'financeProfitReportCategory_v1.8.0',
        dataTotal: {},
        data: [],
        filter: {
          countryMarketValue: {},
          categoryIds: null, // 品类
          currency: '',
          date: {
            key: 0,
            value: new Date()- 3600 * 1000 * 24 * 30,
          }
        },
        columns: [
          { id: "category", header: "品类", field: "category", default: true, minWidth: "100px", disabled: true, fixed: 'left', sortable: true},
          { id: "marketName", header: "店铺/国家", field: "name", minWidth: "120px", default: true, fixed: 'left', disabled: true, sortable: true},
          ...financeProfitReport
        ],
        category: null,
        expenseManagementTable: [],
        shortcuts: [ '本月', '上月' ],
        dateKey : 0,
        defaultSort:{
          prop:'name,alesAmount,salesMoney',
          order:'descending,descending,descending'
        },
        moduleName: 'FINANCE_PROFIT_REPORT',
        notStorage: true
      }
    },
    watch: {
      "filter.date.key"(val) {
        if (val == 1) {
          this.shortcuts = ['今天', '昨天', '近7天', '近30天', '本月', '上月', '本年至今'];
          return;
        }
        this.shortcuts = ['本月', '上月'];
      }
    },
    created() {
      if(this.dateKey !== 1){
        this.queryFeeItemList().then(() => {
          this.$gjNoticeQuery()
        });
      } else {
        this.$gjNoticeQuery()
      }
    },
    methods: {
      // 初始化,重置
      $gjQueryInitParams() {
        return {
          filter: {
            countryMarketValue: {},
            categoryIds: null, // 品类
            currency: '',
            date: {
              key: 0,
              value: new Date()- 3600 * 1000 * 24 * 30,
            }
          },
        }
      },
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{ countryMarketValue: *}}
       */
      $gjCacheCallback(params) {
        return {
          countryMarketValue: params.countryMarketValue
        };
      },
      // 设置参数model
      setModel() {
        let model = {
          countryIds: this.filter.countryMarketValue.countryIds, // 国家
          marketIds: this.filter.countryMarketValue.marketIds, // 店铺
          currency: this.filter.currency,// 币种
          dateType: null, startDate: null, endDate: null,// 月份/日期范围
          categoryIds: this.filter.categoryIds, // 品类
        }
        // 月份/日期范围处理
        model.dateType = String( this.filter.date.key)
        if (this.filter.date.key === 1) {
          model.startDate = convertToFullDate(this.filter.date.value[0], 'yyyy-MM-dd');
          model.endDate = convertToFullDate(this.filter.date.value[1], 'yyyy-MM-dd');
        } else {
          model.startDate = this.filter.date.value ? convertToFullDate(this.filter.date.value, 'yyyy-MM') + '-01' : null;
          model.endDate = this.filter.date.value ? convertToFullDate(this.filter.date.value, 'yyyy-MM') + '-01' : null;
        }
        return model
      },
      // 查询
      $gjQuery() {
        this.loading = true;
        let model = this.setModel()
        this.globalParams = {
          model,
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams.model.queryType = 'category';
        // 获取合计
        analysisStatistics(this.globalParams).then(data => {
          this.dataTotal = data || {}
          if(this.dataTotal.feeItemList && this.dataTotal.feeItemList.length > 0){
            let feeItemList = this.dataTotal.feeItemList;
            feeItemList.forEach(o =>{
              this.dataTotal[o.feeItemName] = o.feePrice;
            })
          }
        })
        // 获取table数据
        getFinanceAnalysisPage(this.globalParams).then((data) => {
          //自定义费用需要拿出来，放在第一级
          this.data = data.records.map((v,idx)=>{
            if(v.feeItemList && v.feeItemList.length>0){
              let feeItemList = v.feeItemList;
              feeItemList.forEach(o =>{
                v[o.feeItemName] = o.feePrice;
              })
            }
            return v;
          });
          this.pagination = this.getPagination(data);
        }).complete(() => this.loading = false)
      },
      queryFeeItemList(){
        const _this = this;
        return queryFeeItemList().then((data)=>{
          const others = {
            id: 'customFee',
            header: '自定义费用',
            field: 'slot:customFee',
            align: "center",
            help: '由MSKU维度的数据汇总计算而来',
            children: []
          };
          data.forEach((v, idx) => {
            const item = {
              id: `${v.feeItemName}`,
              header: v.feeItemName,
              field: `slot:${v.feeItemName}`,
              minWidth: '150px',
              align: 'right',
              prefix: 'currencySymbol',
              default: true,
              summary: true,
            }
            const itemExpenseManagement = {feeItemName: v.feeItemName, canDelete: v.canDelete};
            //后端通过id判断增还是改
            if (v.id) {
              itemExpenseManagement.id = v.id;
            }
            others.children.push(item);
            this.expenseManagementTable.push(itemExpenseManagement);
          })
          this.expenseManagementTable = _.uniqBy(this.expenseManagementTable, 'feeItemName');
          let othersIndex = this.columns.findIndex(item => item.id == 'promotionOtherFee')
          this.columns.splice(othersIndex + 1, 0, others);
          //去重，防止界面多次调用此方法
          _this.columns = _.uniqBy(_this.columns, 'id');
          //PS 深拷贝，插入自定义数据后需要重新渲染界面
          _this.columns = _.cloneDeep(_this.columns);
        })
      },
      clickRecalculate() {
        this.$gjCreate(FinanceRecalculate)
      },
      download() {
        exportProfitAnalysis(this.globalParams);
      },
      //修改日期选择方式
      changeDatePciker(date){
        if(date.key === 1){//选择日期，隐藏自定义费用项
          if(!_.isArray(date.value)){
            this.filter.date = {
              key: 1,
              value: [startOfMonth(new Date()- 3600 * 1000 * 24 * 30), endOfMonth(new Date()- 3600 * 1000 * 24 * 30)],
            };
          }
          if(date.key !== this.dateKey){
            let othersIndex = this.columns.findIndex(item => item.id == 'promotionOtherFee')
            this.columns.splice(othersIndex + 1, 1);
          }
          this.dateKey = 1;
          this.columns = _.cloneDeep(this.columns);
        }else{
          this.filter.date = {key: date.key, value: _.isArray(date.value) ? date.value[0] : (date.value ? date.value : new Date()- 3600 * 1000 * 24 * 30),}
          this.queryFeeItemList().then(() => {
            this.$gjNoticeQuery()
          });
          this.dateKey =0;
        }
      },
    }
  }
</script>

<style scoped>

</style>
